/* eslint-disable */
import React, { useRef, useState, useEffect, useMemo, useContext, useCallback } from 'react'

import { Obj, Options, listIngredients } from './Visualization2D'
import { Vec3, Vec2, norm, normTo1 } from './VectorTools'
import { tup2 } from './GeometryTools'

export function Percentage({ value, image, imagebw, max, min, onChange }
    : { value: number, image: string, imagebw?: string, max?: number, min?: number, onChange: false | ((x: number) => void) }) {
    let p = ((max || 100) - (min || 0)) * (1 - value) + (min || 0);
    let [down, setDown] = useState<boolean>(false);
    let event: React.MouseEventHandler<HTMLDivElement> = e => {
        const rect = (e.target as any).getBoundingClientRect();
        const y = e.clientY - rect.top;
        let top = ((min || 0) / 100) * rect.height;
        let height = (((max || 100) - (min || 0)) / 100) * rect.height;
        const percent = Math.min(1, Math.max((y - top) / height, 0));
        e.preventDefault();
        onChange && onChange(1 - percent);
    };
    return (
        <div className='percentage'
            onMouseDown={e => (setDown(true), event(e))}
            onMouseUp={_ => setDown(false)}
            onMouseLeave={_ => setDown(false)}
            onMouseMove={e => down && event(e)}
            data-value={value} data-disabled={onChange === false}>
            <div><img draggable={false} src={image} /></div>
            <div style={{ height: `${p}%` }}><img draggable={false} src={imagebw || image} /></div>
        </div >
    );
}

export let upd_arr = function <T>(arr: T[], i: number, x: T): T[] {
    return arr.map((o, j) => i == j ? x : o);
}

let nth_ingredient = (i: number) => listIngredients[i] || {
    name: `Ingredient ${i}`, url: 'images/onion.svg' // TODO
};

let eq_vec = function <T>(v1: T[], v2: T[]) {
    return v1.length == v2.length && v1.reduce((acc, x, i) => acc && x == v2[i], true);
}

export let get_shallow_state = (obj: Obj, setObj: (v: Vec3) => void, { min, max } = { min: 0, max: 1 })
    : [Vec3, (i: number, comp: number) => void] => {
    let [fakeVec, setFakeVecRaw] = useState(() => ({
        vec: obj.vec, norm_vec: obj.vec
    }));
    if (!eq_vec(fakeVec.norm_vec, obj.vec)) {
        setFakeVecRaw({ vec: obj.vec, norm_vec: obj.vec });
    }
    let setFakeVec = (i: number, comp: number) => {
        comp = Math.max(Math.min(comp, 1), 0);
        let raw_vec: Vec3 = fakeVec.vec.map((x, j) => j == i ? comp : x) as any;
        let norm_vec = normTo1(raw_vec);
        setFakeVecRaw({ vec: raw_vec, norm_vec });
        setObj(norm_vec);
    }
    return [fakeVec.vec, setFakeVec]
};

function VisualizationTable_client(
    { obj, setObj }: { obj: Obj, setObj: (_: Vec3) => void }
) {
    let [fakeVec, setFakeVec] = get_shallow_state(obj, setObj);
    return (
        <>
            <div className='header widget__table__client--header'>
                <div className="icon widget__table__client--icon">
                    <img src={obj.image} />
                </div>
            </div>
            {fakeVec.map((component, i) =>
                <div key={i} className='component widget__table__client--component'>
                    <span>
                        <input type='number' disabled={!obj.movable} onChange={e => obj.movable && setFakeVec(i, Math.max(Math.min(+e.target.value, 100), 0) / 100)} value={Math.round(component * 100)} />
                    </span>
                    <Percentage onChange={obj.movable && (v => setFakeVec(i, v))} value={component} min={2} max={100}
                        image={listIngredients[i].imgs.cropped} imagebw={listIngredients[i].imgs.croppedBW}
                    />
                </div>
            )}
        </>
    );
}

export let swapSetters = function <T>([l, setL]: [T[], (_: T[]) => void]) {
    return l.map<[T, ((_: T) => void)]>((item, i) => [
        item,
        newitem => setL(l.map((other, j) => i == j ? newitem : other))
    ]);
}
export let as_vec_upd = function <X extends { vec: Vec3 }>(o: X, f: (x: X) => void): ((vec: Vec3) => void) {
    return vec => f(Object.assign(Object.assign({}, o), { vec }));
};

export function VisualizationTable({ objects }: Options) {
    let actors = objects.map(([o, setO]) => tup2(o, as_vec_upd(o, setO)));
    let dim = actors?.[0]?.[0]?.vec?.length || 0;
    let ingredients = new Array(dim).fill(0).map((_, i) => nth_ingredient(i));
    return (
        <div className='table-visualization widget__table'>
            <section className='widget__table__ingredients ingredients'>
                {ingredients.map(({ name, imgs }, i) => <div key={i}>
                    <div className="widget__table__ingredients--icon icon"><img height="12px" src={imgs.normal} /></div>
                    <span className="widget__table__ingredients--name name">{name}</span>
                </div>)}
            </section>
            <section className='widget__table__clients clients'>
                {actors.map(([obj, setObj], i) =>
                    <div className={`client widget__table__client ${obj.className}`} data-kind={'icon' in obj ? 'client' : 'soup'} key={i}>
                        <VisualizationTable_client {...{ obj, setObj }} />
                    </div>
                )}
            </section>
        </div >
    );
}
